
import React, {useState, useEffect} from 'react';
import { firestore } from '../../firebase';
import ProgressBar from './progress_bar'

function RankContainer(props) {
    const [percent, setPercent] = useState(0);
    useEffect(() => {
        setTimeout(() => {
            setPercent(((props.value/props.total)*100).toFixed(1)*3);
        }, 10);
      });

    const fillerStyles = {
        height: '15px',
        width: `${percent}%`,
        backgroundColor: '#FFA200',
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: '1s ease',
      }
   

return  <div key = {props.key} className = 'rank-items'>
<span className = "rank-type">
    {String(props.type)}
</span>
<div className = 'rank-item-container'>
<div style={fillerStyles}>
      <span className = "progress-label-text" ></span>  
    </div>
    <span className ="rank-value">
    {((props.value/props.total)*100).toFixed(1)}% 
</span>
</div>
</div>
}

export default RankContainer;